import React, { useState, useEffect, useCallback } from 'react';
import {
  Text,
  TextInput,
  TouchableOpacity,
  Modal,
  View,
  ActivityIndicator,
} from 'react-native';
import { Picker } from '@react-native-picker/picker';

import {
  getProductCategoriesData,
  getProductFamiliesData,
  getProductLinesData,
  QuickAddProduct,
} from '../../../../api/Product';
import { getBrandsData } from '../../../../api/Price';
import BasicModalContainer from '../../../../common/components/basicmodal/BasicModalContainer';
import ModalHeader from '../../../../common/components/basicmodal/ModalHeader';
import ModalBody from '../../../../common/components/basicmodal/ModalBody';
import ModalFooter from '../../../../common/components/basicmodal/ModalFooter';
import { msgStr } from '../../../../common/constants/Message';
import { useAlertModal } from '../../../../common/hooks';

import { productModalstyles } from './styles/ProductModalStyle';
import { getStoreLocationsData } from '../../../../api/Settings';

const QuickAddProductModal = ({
  isModalVisible,
  setUpdateProductsTrigger,
  closeModal,
  existingProducts,
}) => {

  const { showAlert } = useAlertModal();
  const [ValidMessage, setValidMessage] = useState('');
  const [ValidMessage2, setValidMessage2] = useState('');
  const [ValidMessage3, setValidMessage3] = useState('');
  const [ValidMessage4, setValidMessage4] = useState('');
  const [ValidMessage5, setValidMessage5] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [families, setFamilies] = useState([]);
  const [lines, setLines] = useState([]);
  const [Locations, setLocations] = useState([]);
  // const [PriceGroups, setPriceGroups] = useState([]);
  const StatusArr = [
    { id: 0, status: 'Ready' },
    { id: 1, status: 'Ordered' },
    { id: 2, status: 'Checked out' },
    // { id: 3, status: 'Checked in' },
    { id: 4, status: 'Broken' },
    { id: 5, status: 'Sold' },
    { id: 6, status: 'Transferred' },
    { id: 7, status: 'Stolen' },
    { id: 8, status: 'Trashed' },
  ];

  const [selectedCategory, selectCategory] = useState<{ [key: string]: any }>({});
  const [selectedFamily, selectFamily] = useState<{ [key: string]: any }>({});
  const [selectedLine, selectLine] = useState<{ [key: string]: any }>({});
  const [ProductTxt, setProductTxt] = useState('');
  // const [SizeTxt, setSizeTxt] = useState('');
  // const [DescriptionTxt, setDescriptionTxt] = useState('');
  const [ItemIdTxt, setItemIdTxt] = useState('');
  const [BarcodeTxt, setBarcodeTxt] = useState('');
  const [QuantityTxt, setQuantityTxt] = useState('');
  const [ItemStartingNumberTxt, setItemStartingNumberTxt] = useState('');
  const [SerialNumber, setSerialNumber] = useState('');
  const [HomeLocation, setHomeLocation] = useState('');
  const [CurrentLocation, setCurrentLocation] = useState('');
  // const [selectedPriceGroup, selectPriceGroup] = useState<{ [key: string]: any }>({});
  const [selectedStatus, selectStatus] = useState<{ [key: string]: any }>({});
  const [selectedHomeLocation, selectHomeLocation] = useState<any>({});
  const [selectedCurrentLocation, selectCurrentLocation] = useState<any>({});

  const [Brands, setBrands] = useState([]);
  const [selectedBrand, selectBrand] = useState<number>(0);

  const getStoreLocationId = (storeLoc?: any) => {
    return storeLoc?.locations?.id ?? storeLoc?.location_id ?? null;
  };

  useEffect(() => {
    if (isModalVisible) {
      setQuantityTxt('');
      setItemStartingNumberTxt('');
      selectStatus(StatusArr[0]);
      selectBrand(0);
      setLocations([]);
      selectHomeLocation({});
      selectCurrentLocation({});
      setValidMessage('');
      setValidMessage2('');
      setValidMessage3('');
      setValidMessage4('');
      setValidMessage5('');
    }
  }, [isModalVisible]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getProductCategoriesData();
        const categoriesData = await response.json();
        setCategories(categoriesData);

        if (categoriesData.length > 0) {
          selectCategory(categoriesData[0]);
        } else {
          selectCategory({});
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, [isModalVisible]);
  

  useEffect(() => {
    getBrandsData((jsonRes) => {
      setBrands(jsonRes);
    });
  }, [isModalVisible]);

  const handleBrandChange = async (brandId: number) => {
    selectBrand(brandId);
    if (!brandId) {
      setLocations([]);
      selectHomeLocation({});
      selectCurrentLocation({});
      return;
    }

    await getStoreLocationsData(brandId, (jsonRes, status) => {
      if (status == 200) {
        const nextLocations = jsonRes.storeLocations || [];
        setLocations(nextLocations);
        selectHomeLocation(nextLocations[0] || {});
        selectCurrentLocation(nextLocations[0] || {});
      } else {
        setLocations([]);
        selectHomeLocation({});
        selectCurrentLocation({});
      }
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const categoryId = selectedCategory?.id??0;
        const response = await getProductFamiliesData(categoryId);
          const familiesData = await response.json();
          setFamilies(familiesData);

          if(familiesData.length>0){
            selectFamily(familiesData[0])
          }else selectFamily({});
      } catch (error) {
        console.log(error);
      }
    }
 
    fetchData();
  }, [isModalVisible, selectedCategory]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const familyId = selectedFamily?.id??0;
        const response = await getProductLinesData(familyId);
          const linesData = await response.json();
          setLines(linesData);

          if(linesData.length>0){
            selectLine(linesData[0])
          }else selectLine({});
      } catch (error) {
        console.log(error);
      }
    }
 
    fetchData();
  }, [selectedCategory, selectedFamily]);

  const checkForDuplicates = (lineId: number, itemStartingNumber: number, quantity = 1) => {
    if (!itemStartingNumber) return { hasDuplicates: false, duplicates: [] };
    
    const selectedLineObj = lines.find(line => line.id === lineId);
    if (!selectedLineObj) return { hasDuplicates: false, duplicates: [] };
    
    const lineName = selectedLineObj.line;
    const startingNum = itemStartingNumber;
    const duplicates = [];
    
    for (let i = 0; i < quantity; i++) {
      const currentNumber = startingNum + i;
      const duplicate = existingProducts.find(product => {
        if (!product.line || product.item_starting_number === null || product.item_starting_number === undefined) {
          return false;
        }
        
        const existingLineName = product.line.line;
        const existingStartingNumber = product.item_starting_number;
        
        return existingLineName.toLowerCase() === lineName.toLowerCase() && parseInt(existingStartingNumber) === currentNumber;
      });
      
      if (duplicate) {
        duplicates.push({ number: currentNumber, product: duplicate });
      }
    }
    
    return { 
      hasDuplicates: duplicates.length > 0,
      duplicates: duplicates
    };
  };

  // Function to validate duplicates in real-time with useCallback for optimization
  const validateDuplicates = useCallback(() => {
    if (!selectedLine?.id || !ItemStartingNumberTxt) {
      setValidMessage5('');
      return;
    }
    
    const quantity = parseInt(QuantityTxt) || 1;
    const startingNumber = parseInt(ItemStartingNumberTxt) || 0;
    
    const duplicateCheck = checkForDuplicates(selectedLine.id, startingNumber, quantity);
    
    if (duplicateCheck.hasDuplicates) {
      const duplicateNumbers = duplicateCheck.duplicates.map(d => d.number);
      let displayNumbers;
      
      if (duplicateNumbers.length > 10) {
        // Show first 3 and last 3 numbers with ellipsis in between
        const firstThree = duplicateNumbers.slice(0, 3).join(', ');
        const lastThree = duplicateNumbers.slice(-3).join(', ');
        displayNumbers = `${firstThree}, ... , ${lastThree}`;
      } else {
        // Show all numbers
        displayNumbers = duplicateNumbers.join(', ');
      }
      
      setValidMessage5(`Duplicate items detected for line "${selectedLine.line}" with number(s): ${displayNumbers}. \nPlease choose a different starting number or reduce quantity.`);
    } else {
      setValidMessage5('');
    }
  }, [selectedLine, ItemStartingNumberTxt, QuantityTxt, existingProducts]);

  // Add useEffect for real-time duplicate validation with debounce
  useEffect(() => {
    // Only check if we have all the necessary data
    if (selectedLine?.id && ItemStartingNumberTxt) {
      // Add a small delay to avoid checking on every keystroke
      const timeoutId = setTimeout(() => {
        validateDuplicates();
      }, 300); // 300ms debounce
      
      return () => clearTimeout(timeoutId);
    } else {
      // Clear validation message if any required field is empty
      setValidMessage5('');
    }
  }, [selectedLine, ItemStartingNumberTxt, QuantityTxt, validateDuplicates]);

  const AddProductButtonHandler = () => {
    setValidMessage('');
    setValidMessage2('');
    setValidMessage3('');
    setValidMessage4('');
    setValidMessage5('');
    
    if (!QuantityTxt.trim()) {
      setValidMessage(msgStr('emptyField'));
      return;
    }

    if (!selectedCategory?.id) {
      setValidMessage2('Please select a category.'); // Ensure the user selects a category
      return;
    }

    if (!selectedFamily?.id) {
      setValidMessage3('Please select a family.'); // Ensure the user selects a family
      return;
    }

    if (!selectedLine?.id) {
      setValidMessage4('Please select a line.'); // Ensure the user selects a line
      return;
    }

    setIsLoading(true);

    const homeLocationId = getStoreLocationId(selectedHomeLocation);
    const currentLocationId = getStoreLocationId(selectedCurrentLocation);

    const payload = {
      category_id: selectedCategory.id,
      family_id: selectedFamily.id,
      line_id: selectedLine.id,
      line: selectedLine,
      // description: DescriptionTxt,
      item_id: ItemIdTxt,
      quantity: 1,
      rowcounts: parseInt(QuantityTxt),
      item_starting_number: parseInt(ItemStartingNumberTxt),
      home_location: homeLocationId,
      current_location: currentLocationId,
      status: selectedStatus.id,
    };

    const handleResponse = (jsonRes, status) => {
      switch (status) {
        case 201:
          showAlert('success', jsonRes.message);
          setUpdateProductsTrigger(true);
          closeModal();
          break;
        case 409:
          setValidMessage(jsonRes.error);
          break;
        default:
          if (jsonRes && jsonRes.error) showAlert('error', jsonRes.error);
          else showAlert('error', msgStr('unknownError'));
          closeModal();
          break;
      }
      setIsLoading(false);
    };

    QuickAddProduct(payload, (jsonRes, status) => {
      handleResponse(jsonRes, status);
    });
  };

  const checkInput = () => {
    if (!QuantityTxt.trim()) {
      setValidMessage(msgStr('emptyField'));
    } else {
      setValidMessage('');
    }
  };

  const getLocationLabel = (loc?: {name?: string; location?: string;}) => {
    return `${loc?.name ? loc.name + ' - ' : ''}${loc?.location ?? 'No address available'}`;
  }

  return (
    <Modal
      animationType="none"
      transparent={true}
      visible={isModalVisible}
      onShow={() => {
      }}
    >
      <BasicModalContainer>
        <ModalHeader label={'Quick Add'} closeModal={closeModal} />
        <ModalBody>
          <View style={{ flexDirection: 'row' }}>
            <View style={{ flex: 1, paddingRight: 10 }}>
              <Text style={styles.label}>Category</Text>
              <Picker
                style={styles.select}
                selectedValue={selectedCategory.id}
                onValueChange={(itemValue, itemIndex) => {
                  selectCategory(categories[itemIndex]);
                  // setCategoryChanged(true);
                }}
              >
                {categories.length > 0 &&
                  categories.map((category, index) => {
                    return (
                      <Picker.Item key={index} label={category.category} value={category.id} />
                    );
                  })}
              </Picker>
              {ValidMessage2.trim() != '' && <Text style={styles.message}>{ValidMessage2}</Text>}

              <Text style={styles.label}>Family</Text>
              <Picker
                style={styles.select}
                selectedValue={selectedFamily.id}
                onValueChange={(itemValue, itemIndex) => {
                  selectFamily(families[itemIndex]);
                  // setCategoryChanged(true);
                }}
              >
                {families.length > 0 &&
                  families.map((family, index) => {
                    return <Picker.Item key={index} label={family.family} value={family.id} />;
                  })}
              </Picker>
              {ValidMessage3.trim() != '' && <Text style={styles.message}>{ValidMessage3}</Text>}

              <Text style={styles.label}>Line</Text>
              <Picker
                style={styles.select}
                selectedValue={selectedLine.id}
                onValueChange={(itemValue, itemIndex) => {
                  selectLine(lines[itemIndex]);
                  // Clear validation message when line changes
                  setValidMessage5('');
                }}
              >
                {lines.length > 0 &&
                  lines.map((line, index) => {
                    return (
                      <Picker.Item
                        key={index}
                        label={line.line + ' ' + line.size}
                        value={line.id}
                      />
                    );
                  })}
              </Picker>
              {ValidMessage4.trim() != '' && <Text style={styles.message}>{ValidMessage4}</Text>}

              {/* <Text style={styles.label}>Product</Text>
              <TextInput style={styles.input} placeholder="Product" value={ProductTxt} onChangeText={setProductTxt} placeholderTextColor="#ccc" onBlur={checkInput}/>
              {(ValidMessage.trim() != '') && <Text style={styles.message}>{ValidMessage}</Text>} */}
              {/* <Text style={styles.label}>Size</Text>
              <TextInput style={styles.input} placeholder="Size" value={SizeTxt} onChangeText={setSizeTxt} onBlur={checkInput} placeholderTextColor="#ccc"/> */}
              <Text style={styles.label}>Item Starting Number</Text>
              <TextInput
                style={[
                  styles.input,
                  ValidMessage5.trim() !== '' ? { borderColor: 'red', borderWidth: 1 } : {}
                ]}
                placeholder="Item Starting Number"
                value={ItemStartingNumberTxt}
                keyboardType="numeric"
                onChangeText={(text) => {
                  // Only allow numeric input
                  if (text === '' || /^\d+$/.test(text)) {
                    setItemStartingNumberTxt(text);
                    setValidMessage5('');
                  } else {
                    // Keep the previous valid value
                    setValidMessage5('Only numbers are allowed');
                  }
                }}
                placeholderTextColor="#ccc"
              />
              
              {ValidMessage5.trim() != '' && 
                <View style={{ backgroundColor: '#FFEBEE', padding: 10, borderRadius: 4, margin: 4,}}>
                  <Text style={[styles.message,  { marginBottom: 0,
                      marginTop: 0,
                      paddingLeft: 0}]}>{ValidMessage5}</Text>
                </View>
              }

              <Text style={styles.label}>Quantity</Text>
              <TextInput
                style={[
                  styles.input,
                  ValidMessage.trim() !== '' ? { borderColor: 'red', borderWidth: 1 } : {}
                ]}
                placeholder="Quantity"
                value={QuantityTxt}
                keyboardType="numeric"
                onChangeText={(text) => {
                  // Only allow numeric input
                  if (text === '' || /^\d+$/.test(text)) {
                    setQuantityTxt(text);
                    if (!text.trim()) {
                      setValidMessage(msgStr('emptyField'));
                    } else {
                      setValidMessage('');
                    }
                  } else {
                    // Show error for non-numeric input
                    setValidMessage('Only numbers are allowed');
                  }
                }}
                placeholderTextColor="#ccc"
              />
              {ValidMessage.trim() != '' && 
                <View style={{ backgroundColor: '#FFEBEE', padding: 10, borderRadius: 4, margin: 4,}}>
                  <Text style={[styles.message,  { marginBottom: 0,
                      marginTop: 0,
                      paddingLeft: 0}]}>{ValidMessage}</Text>
                </View>
              }

              <Text style={styles.label}>Brands</Text>
              <Picker
                style={styles.select}
                selectedValue={selectedBrand}
                onValueChange={(itemValue) => {
                  handleBrandChange(itemValue);
                }}
              >
                <Picker.Item label={''} value={0} />
                {Brands.length > 0 &&
                  Brands.map((brand, index) => {
                    return (
                      <Picker.Item key={index} label={brand.brand} value={brand.id} />
                    );
                  })}
              </Picker>

              <Text style={styles.label}>Home Location</Text>
              <Picker
                style={styles.select}
                selectedValue={getStoreLocationId(selectedHomeLocation)}
                onValueChange={(itemValue, itemIndex) => {
                  selectHomeLocation(Locations[itemIndex] || {});
                }}
              >
                {Locations.length > 0 &&
                  Locations.map((location, index) => {
                    return (
                      <Picker.Item
                        key={index}
                        label={getLocationLabel(location.locations)}
                        value={getStoreLocationId(location)}
                      />
                    );
                  })}
              </Picker>

              <Text style={styles.label}>Current Location</Text>
              <Picker
                style={styles.select}
                selectedValue={getStoreLocationId(selectedCurrentLocation)}
                onValueChange={(itemValue, itemIndex) => {
                  selectCurrentLocation(Locations[itemIndex] || {});
                }}
              >
                {Locations.length > 0 &&
                  Locations.map((location, index) => {
                    return (
                      <Picker.Item
                        key={index}
                        label={getLocationLabel(location.locations)}
                        value={getStoreLocationId(location)}
                      />
                    );
                  })}
              </Picker>
              <Text style={styles.label}>Status</Text>
              <Picker
                style={styles.select}
                selectedValue={selectedStatus.id}
                onValueChange={(itemValue, itemIndex) => {
                  selectStatus(StatusArr[itemIndex]);
                }}
              >
                {StatusArr.length > 0 &&
                  StatusArr.map((statusItem, index) => {
                    return (
                      <Picker.Item key={index} label={statusItem.status} value={statusItem.id} />
                    );
                  })}
              </Picker>
              {/* <Text style={styles.label}>Description</Text>
              <TextInput
                style={[styles.input]}
                placeholder="Description"
                value={DescriptionTxt}
                multiline={true}
                onChangeText={setDescriptionTxt}
                placeholderTextColor="#ccc"
              /> */}
            </View>
          </View>
        </ModalBody>
        <ModalFooter>
          <TouchableOpacity onPress={AddProductButtonHandler}>
            <Text style={styles.addButton}>{'Add'}</Text>
          </TouchableOpacity>
        </ModalFooter>
      </BasicModalContainer>
      {isLoading && (
        <View style={styles.overlay}>
          <ActivityIndicator size="large" color="#0000ff" />
        </View>
      )}
    </Modal>
  );
};

const styles = productModalstyles;

export default QuickAddProductModal;
